module.exports = __webpack_public_path__ + "media/images/steps/step_5-1147d52cfbbb00ccbbf5338855635153.svg";